import type React from 'react'
import type { IconProps } from './types'

const RatingAverage: React.FC<IconProps> = ({ size = 20, className = 'fill-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M15.15 16.85L14.325 13.25L17.1 10.85L13.45 10.525L12 7.125V14.925L15.15 16.85ZM5.825 21L7.45 13.975L2 9.25L9.2 8.625L12 2L14.8 8.625L22 9.25L16.55 13.975L18.175 21L12 17.275L5.825 21Z' />
	</svg>
)

export default RatingAverage
